import { ChipProps } from '@mui/material';
import { OrderType } from '../data/models/orders/orderType';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import TakeoutDiningIcon from '@mui/icons-material/TakeoutDining';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import { createElement } from 'react';

export const getOrderTypeChipProps = (
  orderType: OrderType
): {
  icon: ChipProps['icon'];
  color: ChipProps['color'];
  label: string;
} => {
  switch (orderType) {
    case OrderType.Delivery:
      return {
        icon: createElement(DeliveryDiningIcon),
        color: 'primary',
        label: 'orders.type.delivery',
      };
    case OrderType.TakeAway:
      return {
        icon: createElement(TakeoutDiningIcon),
        color: 'secondary',
        label: 'orders.type.takeaway',
      };
    case OrderType.DineIn:
      return {
        icon: createElement(RestaurantIcon),
        color: 'success',
        label: 'orders.type.dine-in',
      };
    default:
      return {
        icon: createElement(RestaurantIcon),
        color: 'default',
        label: 'orders.type.unknown',
      };
  }
};
